import { t } from 'i18next'

import { AssertionError } from '@/shared/lib/errors/AssertionError'

import { wwtErrorLog } from '../../logger/wwtErrorLog'
import { ErrorHandlerResult } from '../../types/ErrorHandlerResult'

export const assertionErrorHandler = (
	error: AssertionError
): ErrorHandlerResult => {
	wwtErrorLog(`Assertion error!`, error.message)

	const title = t(`client.assertion.title`, { ns: 'errors' })
	const description = t(`client.assertion.description`, { ns: 'errors' })

	return {
		reset: true,
		toastInfo: {
			id: `assertion-${error.message}`,
			title,
			description,
			variant: 'clientFailure'
		}
	}
}
